import type { VoidFunctionComponent } from 'react';

import { get } from '../../../redux/api';
import { selectOptionFactory } from '../../../utils';
import FormLabel from '../../generic/Forms/FormLabel';
import AsyncSelect from '../../generic/Select/AsyncSelect';
import type { CveWithDetails } from '../../../../shared/vulns/types';

/**
 * Render an autocomplete dropdown to allow user to filter their packages base on CVEs.
 */
const VulnCVE: VoidFunctionComponent<{
  cve: string;
  setFilters: (...args: unknown[]) => void;
}> = ({ setFilters, cve }) => {
  return (
    <FormLabel label="CVE">
      <AsyncSelect
        isClearable
        defaultOptions
        cacheOptions
        value={cve ? { label: cve, value: cve } : null}
        placeholder="Select a CVE..."
        loadOptions={async (search) => {
          const { data } = await get<CveWithDetails[]>(`/api/vulns/cve-list?query=${search || ''}`, true);
          if (!data) {
            return [];
          }
          const cves = data?.map((cveWithDetail) => cveWithDetail.cve);
          const distinctCves = [...new Set(cves)];

          return distinctCves?.map((distinctCve) => selectOptionFactory(distinctCve));
        }}
        onChange={(option) => {
          if (!option) {
            setFilters({
              cve: null,
            });
          }
          setFilters({
            cve: option?.value,
          });
        }}
      />
    </FormLabel>
  );
};

export default VulnCVE;
